import  { FC } from 'react'
import { RotationRightButton } from "../../../../components/buttons/iconButtons/action/RotationCollection"
import { HighLightButton } from "../../../../components/buttons/iconButtons/editor/ActionCollection"
import BaseCommandsPanel from "../../../../components/commandsPanels/BaseCommandsPanel"
import Tooltip from "../../../../components/tooltips/Tooltip"
import { checkActiveCommands } from '../../../CommonHelperFunctions'
import { useUserContext } from '../../../../system/providers/userContextProvider'
import { useTranslation } from 'react-i18next'
import { Input, Button } from "antd"
import { SearchIcon } from '../../../../libs/corporate/icons/outlined/action/MainCollection'

interface IPanelEvent {
    disabled?: boolean
    onClick: () => void
}
interface ISysOptionsCommandPanelProps {
    edit?: IPanelEvent    
    refresh?: IPanelEvent
    search?: IPanelSearchEvent
    permission?: IPermission
}

interface IPanelSearchEvent {
    value: string
    placeholder?: string,
    onChange: (value: string) => void
    onSearch: (value: string) => void
}

export const SysOptionsCommandPanel: FC<ISysOptionsCommandPanelProps> = (props) => {
    
    const userContext = useUserContext();
    const activeCommands = checkActiveCommands(props.permission as IPermission, userContext.userPermission);
    
    const { t } = useTranslation();

    return (
        <div style={{display: 'flex', alignItems: 'center', marginRight: 10}}>
            <BaseCommandsPanel groups={[
                [              
                    {
                        iconButton: <Tooltip title="Редактировать запись">
                            <HighLightButton sizeVariant="mini" {...{...props.edit, disabled: props.edit?.disabled || !activeCommands.edit}} />
                        </Tooltip>
                    },
                ],
                [    
                    {
                        iconButton: <Tooltip title="Обновить">
                            <RotationRightButton sizeVariant="mini" {...{...props.refresh, disabled: props.refresh?.disabled || !activeCommands.refresh}} />
                        </Tooltip>
                    }
                ]
            ]} />
            {props.search && (
                <Input
                    className="custom-input-withPrefix"
                    style={{marginBottom: 0}}
                    value={props.search.value}
                    placeholder={t("sysOptions.searchPlaceholder")}
                    prefix={<SearchIcon />}
                    onPressEnter={(e) => props?.search?.onSearch?.((e.target as HTMLInputElement).value)}
                    onChange={(e) => props?.search?.onChange?.(e.target.value)}
                    allowClear
                />
            )}
        </div>
        
    )
}